import { h } from 'preact';
import { useThreekit } from '../threekit-context';

function BackgroundContainer() {
  const { backgroundColor } = useThreekit();

  return !backgroundColor ? null : (
    <div
      id="background-container"
      className="absolute w-screen h-screen z-[-1] bg-grey-500 top-0 transition-all duration-500 ease-in-out"
      style={{
        background: backgroundColor.hex,
        filter: backgroundColor.wasFallback ? 'brightness(30%)' : '',
      }}
    />
  );
}

export default BackgroundContainer;
